import _ from 'lodash'

const methods = [
  'config',
  'provider',
  'factory',
  'service',
  'value',
  'constant',
  'decorator',
  'filter',
  'controller',
  'directive',
  'component',
  'run',
  'route',
  'mock',
]

const multipleMethods = ['configs', 'constants', 'routes']

let ngModules = {}

/**
 * Retrieves the list of registed Angular modules.
 *
 * @returns {array<string>} The list of modules
 */
let getNgModules = () => Object.keys(ngModules)

/**
 * @todo Document
 *
 * @param {string} ngModuleName The name of the angular module to add to the registry
 * @param {array<object>} modules @todo Document
 * @returns {object} The angular module
 */
function registerNgModules(ngModuleName, ...modules) {
  // The first time a module is registered, we create it. Subsequent calls of
  // register to the same module will simply add new methods to the module.
  ngModules[ngModuleName] =
    ngModules[ngModuleName] ?? angular.module(ngModuleName, [])

  modules.forEach(moduleMethods => {
    for (let method in moduleMethods) {
      if (!moduleMethods.hasOwnProperty(method)) {
        continue
      }

      let args = moduleMethods[method]

      // Support services as ES6 classes.
      if (args.ngType !== undefined) {
        args = [method, args]
        method = args[1].ngType
      }

      if (
        methods.indexOf(method) === -1 &&
        multipleMethods.indexOf(method) === -1
      ) {
        throw new Error(
          `ngModuleRegistry: Unsupported method "${method}" from module ${ngModuleName}`
        )
      }

      // Multiple method: remove the final "s".
      let multiple = multipleMethods.indexOf(method) > -1
      if (multiple) {
        method = method.slice(0, -1)
      }
      // Single method, convert args to array.
      else {
        args = [args]
      }

      // Routes.
      if (method == 'route') {
        ngModules[ngModuleName].config(
          /*@ngInject*/ TmrRoutesProvider => {
            // Merge routes with the same name: allows easy override of routes in customizations
            args.forEach(route => {
              let prevRoute = TmrRoutesProvider.getRoute(route.name)
              if (prevRoute === undefined) TmrRoutesProvider.routes.push(route)
              else _.merge(prevRoute, route)
            })
          }
        )
      }
      // Mocks.
      else if (method == 'mock') {
        ngModules[ngModuleName].config(
          /*@ngInject*/ TmrDevelResourceMockProvider => {
            args.forEach(mock => TmrDevelResourceMockProvider.register(mock))
          }
        )
      } else {
        // Where the magic happens. This automatically chains all those tedious
        // angular.module().config(..).factory(...).run(...).controller(...) etc...
        // When method is "config" or "run", we allow passing args as function
        // for simplicity, but spread needs an array.
        args.forEach(a =>
          ngModules[ngModuleName][method](...(Array.isArray(a) ? a : [a]))
        )
      }
    }
  })

  return ngModules[ngModuleName]
}

/**
 * Allows registration of additional vendor modules. May be used by customizations.
 *
 * @param {array<string>|string} modules The list of vendor modules
 */
function registerVendorNgModules(modules) {
  if (typeof modules === 'string') {
    modules = [modules]
  }
  modules.forEach(module => {
    if (ngModules[module] !== undefined) {
      throw new Error(
        'There was an attempt to register the same vendor Angular module multiple times'
      )
    }
    ngModules[module] = null
  })
}

export {
  getNgModules as ngModules,
  registerNgModules as register,
  registerVendorNgModules as registerVendors,
}
